import { Breadcrumb } from 'antd';
import { useTranslation } from 'react-i18next';

import { DefaultLayout } from '@/component';
import { ContentHeader } from '@/views/importLicensing/importLicensingList/ContentHeader';
import { List } from '@/views/importLicensing/importLicensingList/List';

export const ImportLicensingListPage = () => {
  const { t } = useTranslation(['importLicensingInfo']);

  return (
    <DefaultLayout>
      <DefaultLayout.Header>
        <Breadcrumb>
          <Breadcrumb.Item>{t('importLicensingInfo:listPage.title')}</Breadcrumb.Item>
        </Breadcrumb>
      </DefaultLayout.Header>
      <DefaultLayout.Content>
        <ContentHeader />
        <List />
      </DefaultLayout.Content>
    </DefaultLayout>
  );
};
